import React, { useState, useEffect } from "react";
import hash from "@emotion/hash";

import GoogleSearchItem from "./components/GoogleSearchItem/GoogleSearchItem.jsx";
import BlacklistSearchItem from "./components/BlacklistSearchItem/BlacklistSearchItem.jsx";

import { getSearch } from "./api/search";
import { getCache, setCache } from "../../../../utils/cache.js";

import styles from "./ApiSearch.module.scss";

const ApiSearch = ( { query, trigger, lineNumber, incrementLine, activeLine, setLineLinks } ) => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [timer, setTimer] = useState(null);
    const [startLineNumber, setStartLineNumber] = useState(lineNumber);

    const prefix = 'search:';

    const handleSubmit = () => {
        if (timer) {
            clearTimeout(timer);
        }
        setTimer(setTimeout(() => {
            setLoading(true);
            setResponse(null);
            getSearch(query).then(r => {
                if (Object.keys(r?.data)?.length > 0) {
                    setResponse(r.data);
                    incrementLine(Object.keys(r.data)?.length);
                    setCache(prefix + hash(query), r.data);
                }
                else {
                    setResponse([]);
                }
            }).catch(e => setError(e)).finally(() => setLoading(false));
        }, 1000))
    }

    useEffect(() => {
        setResponse(null);

        const responseCache = getCache(prefix + hash(query));

        if (responseCache) {
            setResponse(responseCache);
        } else if (trigger && query && query.length > 2) {
            handleSubmit()
        }
        else if (timer) {
            clearTimeout(timer);
        }

    }, [trigger, query]);

    useEffect(() => {
        setStartLineNumber(lineNumber - response?.length);
    }, [lineNumber, response?.length]);

    return (
        <>
            {loading && <p className={styles.loading}>Loading...</p>}

            {Object.keys(response || {})?.length > 0 && (
                <>
                    {response?.blacklistIp && Object.keys(response?.blacklistIp || {})?.length > 0 && (
                        <>
                            <ul className={styles.list}>
                                {[ ...response?.blacklistIp].map((i, k) => <BlacklistSearchItem item={i} key={k}
                                                                        link={i?.ip}
                                                                        lineNumber={startLineNumber + k}
                                                                        active={startLineNumber + k === activeLine}
                                                                        setLineLinks={setLineLinks}/>)}
                            </ul>
                        </>
                    )}

                    {response?.blacklistEmail && Object.keys(response?.blacklistEmail || {})?.length > 0 && (
                        <>
                            <ul className={styles.list}>
                                {[ ...response?.blacklistEmail].map((i, k) => <BlacklistSearchItem item={i} key={k}
                                                                        link={i.email}
                                                                        lineNumber={startLineNumber + k}
                                                                        active={startLineNumber + k === activeLine}
                                                                        setLineLinks={setLineLinks}/>)}
                            </ul>
                        </>
                    )}

                    {response?.google && response?.google?.items && Object.keys(response?.google?.items || {})?.length > 0 && (
                        <>

                            <p className={styles.title}>Search results across all of CleanTalk.org</p>

                            <ul className={styles.list}>
                                {[ ...response?.google?.items].map((i, k) => <GoogleSearchItem item={i} key={k} lineNumber={startLineNumber + k}
                                                                        active={startLineNumber + k === activeLine}
                                                                        setLineLinks={setLineLinks}/>)}
                            </ul>
                        </>
                    )}
                </>
            )}

            {response !== null && response.length === 0 && (
                <p className={styles.noresult}>No results found in Help or across cleantalk.org. Don’t give up — send us
                    a message at welcome@cleantalk.org, we’re happy to assist!</p>
            )}

            {
                error && (
                    <p className={styles.error}>Something went wrong. Try again</p>
                )
            }
        </>
    )
};

export default ApiSearch;
